import type { IndicatorKey } from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/period-summary/model/IndicatorKey.ts";
import useIndicatorLabelAndUnit from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/period-summary/model/useIndicatorLabelAndUnit.ts";
import type { ReactNode } from "react";

interface Properties {
  indicatorKey: IndicatorKey;
}
export default function RecapTableHeader(props: Properties): ReactNode {
  const { label } = useIndicatorLabelAndUnit(props.indicatorKey);
  return <th className="recap-header-cell">{label}</th>;
}
